// Alpine.js Splide re-initialization component for Shopify Editor
export default {
  name: 'splideReinit',
  component() {
    return {
      init() {
        const reinit = () => {
          document.querySelectorAll('.splide').forEach(function (el) {
            if (el.splideInstance) {
              el.splideInstance.destroy();
            }
            try {
              var options = el.getAttribute('data-splide');
              if (options) {
                var opts = typeof options === 'string' ? JSON.parse(options) : options;
                if (window.enableDebugMode) { console.log('Splide re-initialize', opts); }
                el.splideInstance = new Splide(el, opts);
                el.splideInstance.mount();
                if (window.enableDebugMode) { console.log('Splide re-initializ-ed', el.splideInstance); }
              }
            } catch (e) {
              // Fail silently
              if (window.enableDebugMode) { console.log('Could not initialize splide'); }
            }
          });
        };
        document.addEventListener('shopify:section:load', reinit);
        document.addEventListener('shopify:section:select', reinit);
        document.addEventListener('shopify:block:select', reinit);
        document.addEventListener('shopify:block:deselect', reinit);
        // Optionally run on Alpine init
        reinit();
      }
    }
  }
}
